module.exports = __webpack_public_path__ + "img/profile-photo-small.514bb179.jpg";